module.exports = __webpack_public_path__ + "static/media/logos_50h_twongas.17fdc171.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_twongas.jpg
// module id = 227
// module chunks = 0